import React from "react";
import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Typography from "@/foundation/Typography/V2";

function PinkBox() {
  return (
    <Wrapper>
      <IconContainer>
        <StyledSvgSprite icon={"icon-mail-5"} fill="#576BE3" />
      </IconContainer>
      <TopRow>
        <HeaderText variant="label1">
          Our inboxes deserve to receive more than just work emails, right?
        </HeaderText>
        <ContentText variant="paragraph2">
          We understand that you probably receive hundreds of emails per week,
          so we wanted to create something that you'd look forward to!
        </ContentText>
      </TopRow>
    </Wrapper>
  );
}

export default PinkBox;

const Wrapper = styled(FlexDiv)`
  flex-direction: row;
  padding: 20px 24px 20px 24px;
  align-items: flex-start;
  gap: 20px;
  border-radius: 20px;
  background: #e9d3f1;
  @media only screen and (max-width: 600px) {
    padding: 24px 16px;
    border-radius: 16px;
    gap: 12px;
  }
`;

const TopRow = styled(FlexDiv)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  @media only screen and (max-width: 600px) {
    gap: 10px;
  }
`;

const IconContainer = styled(FlexDiv)`
  justify-content: center;
  align-items: center;
  height: 56px;
  width: 56px;
  flex-shrink: 0;
  svg {
    height: 100%;
    width: 100%;
  }
  @media only screen and (max-width: 600px) {
    height: 32px;
    width: 32px;
    svg {
      height: 100%;
      width: 100%;
    }
  }
`;

const HeaderText = styled(Typography)`
  flex: 1;
  max-width: 493px;
  color: #282828;
  font-size: 16px;
  font-family: var(--mori) !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media only screen and (max-width: 600px) {
    max-width: 259px;
    color: #282828;
    font-size: 16px;
    font-family: var(--mori);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

const ContentText = styled(Typography)`
  color: #293056;
  font-size: 14px;
  font-family: var(--mori) !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0px;
  @media only screen and (max-width: 600px) {
    color: #293056;
    font-size: 14px;
    font-family: var(--mori);
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
